// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--he2jm";
export var banner_laptop = "banner-module--banner_laptop--4sHhr";
export var banner_mobile = "banner-module--banner_mobile--bYahM";
export var banner_desktop = "banner-module--banner_desktop--8vbuW";